import { render, staticRenderFns } from "./newLeaveTypePropertyGroup.vue?vue&type=template&id=fbe6648e&"
import script from "./newLeaveTypePropertyGroup.vue?vue&type=script&lang=js&"
export * from "./newLeaveTypePropertyGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VCol,VForm,VRow,VSheet,VTextarea})


/* hot reload */
if (module.hot) {
  var api = require("D:\\Mega\\MRC\\mrc-ess-fronted\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fbe6648e')) {
      api.createRecord('fbe6648e', component.options)
    } else {
      api.reload('fbe6648e', component.options)
    }
    module.hot.accept("./newLeaveTypePropertyGroup.vue?vue&type=template&id=fbe6648e&", function () {
      api.rerender('fbe6648e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Page/EssAdmin/Leave/LeaveTypePropertyGroup/newLeaveTypePropertyGroup.vue"
export default component.exports